import { useMarketData } from "@/pages/quotation/use-market-data";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SearchOutlined } from "@ant-design/icons";
import { useEffect, useRef } from "react";
import { getText } from "@/utils/util";

export function TopScroll() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { marketData } = useMarketData();
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 注入动画样式
    const style = document.createElement('style');
    style.textContent = `
      @keyframes scrollText {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      .market-scroll {
        animation: scrollText 20s linear infinite;
      }
      .market-scroll:hover {
        animation-play-state: paused;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Double the data for continuous scrolling
  const doubledMarketData = [...marketData, ...marketData];

  return (
    <div className="w-full bg-neutral-100 h-10 flex items-center">
      <div className="container mx-auto px-4 flex items-center gap-4">
        {/* 搜索按钮 */}
        <div 
          className="flex items-center gap-2 px-4 py-2 bg-gray-500 rounded-full cursor-pointer shadow-sm hover:shadow-md transition-shadow"
          onClick={() => navigate('/quotation')}
        >
          <SearchOutlined className="text-gray-100" />
          <span className="text-gray-100 text-sm hidden sm:inline">
            {t(getText('搜索幣種'))}
          </span>
        </div>

        {/* 市场数据滚动区 */}
        <div className="flex-1 overflow-hidden">
          <div ref={scrollRef} className="flex market-scroll">
            {doubledMarketData.map((item, index) => (
              <div key={`${item.id}-${index}`} className="flex items-center gap-4 px-3 whitespace-nowrap">
                <div className="font-medium text-white">
                  {item.id.toUpperCase()}
                </div>
                <div className="text-sm text-gray-400">
                  {item.price}
                </div>
                <div
                  className={`text-sm font-medium ${
                    item.change.startsWith("+")
                      ? "text-success"
                      : item.change.startsWith("-")
                      ? "text-danger" 
                      : "text-neutral-400"
                  }`}
                >
                  {item.change}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
